<template>
    <section class="chat-new" @click="$store.dispatch('changeState', {element: 'new_chat', val: false})">
            <div class="chat-new-container" @click.stop>
                    <div class="chat-new-close" @click="$store.dispatch('changeState', {element: 'new_chat', val: false})">
                        <img src="@/assets/images/icons/icon_close.svg" width="18px">
                    </div>
                    <div class="chat-new__string">
                        <div class="chat-new__input">
                            <img src="@/assets/images/icons/icon_list.svg">
                            <input type="text" placeholder="Название чата" v-model="title" />
                        </div>
                        <div class="chat-new-avatar" >
                            <div class="chat-new__avatar" :style="{backgroundImage: 'url('+ cover +')'}">
                                <img src="@/assets/images/icons/image.svg" v-if="!cover && !loading">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="#2E3A59" viewBox="0 0 24 24" v-else-if="loading">
                                    <path
                                        d="M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h14a2 2 0 012 2v14a2 2 0 01-2 2zM5 5v14h14V5H5zm13 12H6l3-4 1 1 3-4 5 7zm-9.5-6a1.5 1.5 0 110-3 1.5 1.5 0 010 3z"
                                    />
                                </svg>
                            </div>
                            <!-- <p>Добавить обложку</p> -->
                            <input class="add-photo-field" 
                                type="file" 
                                @change="loadPhoto" 
                                name="chat_cover" 
                                max-size="5000" 
                                accept="image/*"
                            />
                        </div>
                    </div>
                    <div class="chat-new__input">
                        <img src="@/assets/images/icons/icon_search-g.svg">
                        <input type="search" placeholder="Поиск по пользователям" v-model="search" @keyup="setSearch()">
                    </div>

                    <div class="chat-new-list" >
                        <!-- <div class="chat-new-group">
                            <p class="chat-new-label">Друзья</p>
                            <div class="chat-new-user" v-for="user in getChatUsers" :key="user.id" @click="addUser(user)" :class="{'added': hasUser(user)}">
                                <div class="chat-new-user__check">
                                    <img src="@/assets/images/icons/icon_check-user.svg">
                                </div>
                                <div class="chat-new-user__avatar" :style="{backgroundImage: 'url(' + user.avatar + ')'}"></div>
                                <div class="chat-new-user-info">
                                    <h6>{{ user.firstname + ' ' + user.lastname}}</h6>
                                    <div class="chat-new-user-categories">
                                        <span class="orange">skateboard</span>
                                        <span class="blue">snowboard</span>
                                    </div>
                                </div>
                            </div>
                        </div> -->
                        <div class="chat-new-group" v-if="data">
                            <p class="chat-new-label">Глобальный поиск ({{data.count}})</p>
                            <UserMini 
                                v-for="user in data.users" 
                                :key="user.id" 
                                :user="user"
                                :added="added"
                            />
                        </div>
                    </div>
                    <div class="chat-new-buttons">
                        <div class="chat-new-buttons__button" @click="locked = !locked">
                            <font-awesome-icon icon="unlock-alt" v-if="locked" />
                            <font-awesome-icon icon="lock" v-else />
                            <p>{{ locked ? 'Сделать чат публичным' : 'Сделать чат приватным' }}</p>
                        </div>
                        <div class="chat-new-buttons__button create" @click="createChat()">
                            <font-awesome-icon icon="plus" />
                            <p>Создать чат</p>
                        </div>
                    </div>
        </div>
    </section>
</template>
<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUnlockAlt, faPlus, faLock, faImage } from '@fortawesome/free-solid-svg-icons'
library.add(faUnlockAlt, faLock, faPlus, faImage)

export default {
    name: 'AddChat',
    data: () => {
        return {
            added: [],
            locked: true,
            can_add: true,
            title: '',
            search: '',
            data: null,
            cover: null,
            page: 0,
            loading: false
        }
    },
    components: {
        UserMini: () => import('@/components/Users/UserMini')
    },
    computed: {
        getUser () {
            return this.$store.getters.getAuthUser
        }
    },
    sockets: {
        create_chat (chat) {
            if (chat && !chat.error) {
                this.$store.dispatch('addChat', chat)
                this.$store.dispatch('changeState', {element: 'new_chat', val: false})
                this.$store.dispatch('addNotification', {message: 'Чат создан!'})
                this.$router.push({name: 'chat', params: {hash: chat.id + '&' + chat.hash}})
            } else {
                this.$store.dispatch('addError', {message: 'Что то пошло не так...'})
            }
        }
    },
    methods: {
        // TODO: общая функция загрузки изображений
        loadPhoto(input) {
            let element = input.target.files[0];
            if (element.size / 1024 > 5000) {
                this.$store.dispatch('addError', {message: 'Размер одной из фотографий превышает 5MB'});
            } else {

                var reader = new FileReader();
                reader.readAsDataURL(element)
                reader.onload = async () => {
                let url = reader.result.split('base64,')[1];
                let type = element.type.split('/')[1];
                let size = element.size / 1024;
                let path = 'chats';
                let name = this.$moment().format('ss-mm-HH_DD-MM-YYYY') + '_' + Math.round(Math.random() * 1000);
                this.loading = true;
                await this.$store.dispatch('uploadImage', {url, type: type || 'jpeg', name, size, path, resize: 70}).then(response => {
                    this.loading = false;
                    response.Location ? this.cover = response.Location : (this.cover = null, this.$store.dispatch('addError', {message: 'Не удалось загрузить изображение'}));
                    // this.addPhoto(response.Location)
                }).catch(e => {e
                    this.loading = false;
                    this.cover = null;
                    this.$store.dispatch('addError', {message: 'Не удалось загрузить изображение'})
                });
                };

                reader.onerror = function() {
                this.$store.dispatch('addError', {message: 'Что-то пошло не так...'})
                };
                
            }
        },
        createChat () {
            this.added.push(this.getUser.id)
            let author = {
                id: this.getUser.id,
                firstname: this.getUser.firstname,
                lastname: this.getUser.lastname,
                avatar: this.getUser.avatar,
            };
            let data = {
                title: this.title,
                users: this.added,
                author: author,
                locked: this.locked,
                can_add: this.can_add,
                cover: this.cover
            };
            if (!data.title) {
                this.$store.dispatch('addError', {message: 'Добавьте название чата'})
            } else if (!data.users || data.users.length < 1) {
                this.$store.dispatch('addError', {message: 'Добавьте хотя бы одного человека'})
            } else {
                this.$socket.emit('create_chat', data)
            }
        },
        async loadData() {
            let params = {
                search: this.search,
                type: 'users',
                user: this.getUser.id,
                page: this.page
            };
            this.data = this.search.length > 2 || this.search.length === 0 ? await this.$store.dispatch('getUsers', params) : null;
        },
        setSearch() {
            this.loadData()
        }
    },
    mounted() {
        this.loadData()
    }
}
</script>